import * as React from 'react'

import {handleHubspotResponse} from '@/common/utils'
import Button from '@/components/Button'

const EmailForm = ({
  placeholder,
  submitButton,
  loadingMessage,
  successMessage: successMessagePlaceholder,
  portalId,
  formId,
}) => {
  const [isLoading, setIsLoading] = React.useState(false)
  const [successMessage, setSuccessMessage] = React.useState()
  const [errorMessage, setErrorMessage] = React.useState()

  async function handleSubmit(e) {
    e.preventDefault()

    try {
      setIsLoading(true)
      setSuccessMessage()
      setErrorMessage()

      const form = e.target
      const formData = new FormData(form)

      const response = await fetch(
        `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formId}`,
        {
          method: 'post',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            fields: [
              {
                objectTypeId: '0-1',
                name: 'email',
                value: formData.get('email'),
              },
            ],
          }),
        }
      )

      if (response.ok) {
        await handleHubspotResponse(response, (message) =>
          setSuccessMessage(message || successMessagePlaceholder)
        )
      } else {
        const {errors = []} = await response.json()
        throw Error(errors[0]?.message)
      }
    } catch (error) {
      setErrorMessage(error.message)
    } finally {
      setIsLoading(false)
    }
  }

  if (successMessage) {
    return (
      <p
        className='body-m-regular w-fit py-2 text-yellow-400'
        dangerouslySetInnerHTML={{__html: successMessage}}
      />
    )
  }

  return (
    <>
      <form
        onSubmit={handleSubmit}
        className='body-m-medium relative z-40 flex w-full max-w-md items-center gap-2 rounded-2xl bg-white bg-opacity-10 px-3'
      >
        <input
          className='relative w-0 flex-1 bg-transparent py-4 text-white ring-0 placeholder:text-white placeholder:opacity-40 focus:outline-none focus:ring-0 md:w-full'
          type='email'
          name='email'
          required
          placeholder={placeholder}
        />

        <Button
          as='button'
          className='flex-none whitespace-nowrap'
          size='m'
          theme='email'
          label={isLoading ? loadingMessage : submitButton}
          disabled={isLoading}
        />
      </form>
      {!!errorMessage && (
        <p className='body-m-regular w-full px-4 py-2 text-red-800'>{errorMessage}</p>
      )}
    </>
  )
}

export default EmailForm
